import React from 'react'
import Wrapper from './layout/Wrapper'
import createShareButton from './create/ShareButton'
import Input from './create/Input'
import ShareMessage from './create/ShareMessage'

function Create() {
  return (
    <Wrapper>
      <h1>Play hangman!</h1>
      <p>
        <Input/>
      </p>
      <p>
        <ShareButton/>
      </p>
      <p>
        <ShareMessage/>
      </p>
    </Wrapper>
  )
}


const ShareButton = createShareButton()

export default Create